import { useMocks } from '../../shared/env';
import type { JobRoleGateway } from './JobRoleGateway';
import { HttpJobRoleGateway } from './HttpJobRoleGateway';
import { MockJobRoleGateway } from './MockJobRoleGateway';

export const jobRoleGateway: JobRoleGateway = useMocks ? new MockJobRoleGateway() : new HttpJobRoleGateway();
export type { JobRoleGateway } from './JobRoleGateway';
